import React, { Fragment } from "react";
import BulkActionApproveButton from "./BulkActionApproveButton";
import BulkActionRejectButton from "./BulkActionRejectButton";
import ApproveAllButton from "./ApproveAllButton";
import BulkActionDeleteButton from "./BulkActionDeleteButton";
import { useListContext } from "react-admin";

const BulkConfirmButton = (props: any) => {
  const listContext = useListContext();
  const filterValues = listContext?.filterValues || {};

  return (
    <Fragment>
      {props.isPending && <BulkActionApproveButton {...props} />}
      {props.isPending && <BulkActionRejectButton {...props} />}
      <BulkActionDeleteButton {...props} />
      {props.isPending && (
        <ApproveAllButton
          schoolId={filterValues.SchoolId}
          subcontractorId={filterValues.SubcontractorId}
        />
      )}
    </Fragment>
  );
};

export default BulkConfirmButton;
